import React, { useEffect, useState, useContext } from 'react';
import { Empty } from 'udesk-ui';
import Udesk from 'Udesk';
import CommentDispalyItem from 'Component/common/gong/comment-dispaly-item';
import '../style.scss';
import Locales from 'UdeskLocales';
import { getIntelligentPartnerNotificationShareList } from 'src/api/intelligentPartnerNotification/share/list/index';
import { MessageUserNotificationFoundResponse } from 'src/api/types';
import UdeskPagination from 'Component/common/udesk-pagination';
import { putIntelligentPartnerTaskFinishRecordsShareLogByShareIdStatus } from 'src/api/intelligentPartnerTaskFinishRecords/shareLog/{shareId}/status/index';
import { MsgCenterContext } from 'src/pages/home';

const locales = Locales['current'];

interface ReplyData extends MessageUserNotificationFoundResponse {
    commentItemProps: any,
}
function CoachMsgCenterShare(props) {
    const msgNoticeCountData = useContext(MsgCenterContext);
    const [page, setPage] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [listData, setListData] = useState<ReplyData[]>([]);
    const pageChanged = (pageNum, pageSize) => {
        setPage({
            ...page,
            current: pageNum,
            pageSize,
        });
        getShareData(pageNum, pageSize);
    };
    const getShareData = (pageNum, pageSize) => {
        const params = {
            pageNum,
            pageSize,
        };
        getIntelligentPartnerNotificationShareList({ params }).then((res) => {
            let listData = res.data?.map((item) => {
                return {
                    ...item,
                    commentItemProps: {
                        isHideReply: true,
                        textType: locales.pages.gong.msgCenter.share.index.shareCasesForYou,
                        // beginTime: item.message?.replayComment?.beginTime??0,
                        // text: item.message?.content, //回复的消息的摘要
                        createUserUserName: item?.fromUserName ?? '--', //评论创建人
                        createTime: item?.shareTime, //评论创建时间
                        content: item?.shareReason, //评论内容
                        // replyUserName: item.message?.senderUser?.realname, //回复谁
                        headPortraitUrl: item?.fromUserPortraitUrl, //头像链接
                    },
                };
            });
            setListData(listData ?? []);
            setPage({
                current: res.paging?.pageNum || page.current,
                pageSize: res.paging?.pageSize || page.pageSize,
                total: res.paging?.total || page.total,
            });
        });
    };
    const timeFormat = (value) => {
        let hh: number = Math.floor(value / 60 / 60);
        let mm: number = Math.floor((value / 60) % 60);
        let ss: number = Math.floor(value % 60);
        return (hh < 10 ? '0' + hh : hh) + ':' + (mm < 10 ? '0' + mm : mm) + ':' + (ss < 10 ? '0' + ss : ss);
    };
    const readMessage = (item) => {
        putIntelligentPartnerTaskFinishRecordsShareLogByShareIdStatus({
            segments: { shareId: item?.shareId },
        }).then((res) => {
            msgNoticeCountData && msgNoticeCountData();
            const routeOptions = {
                history: props.history,
                routeName: 'coachLearningCenterRecordDetail',
                pathParams: { id: item.recordId },
                state: { type: 'share' },
            };
            Udesk.ui.routing.transitionTo(routeOptions);
        });
    };
    const handlerOpenDetail = (item) => {
        readMessage(item);
    };
    useEffect(() => {
        getShareData(page.current, page.pageSize);
    }, []);
    return (
        <React.Fragment>
            {listData.length ? (
                listData.map((item:any) => {
                    return (
                        <div key={item.id} className="page-qa-message-center-notice-item">
                            <CommentDispalyItem
                                {...item.commentItemProps}
                                editorWrapperClassName="udesk-qa-ui-input"
                            ></CommentDispalyItem>
                            <div
                                onClick={handlerOpenDetail.bind(null, item)}
                                className="message-center-audio-message"
                            >
                                <div className="message-center-audio-message-text">
                                    <h3>
                                        {item?.userName || '--'} | {item?.taskName || '--'}
                                    </h3>
                                    <p>{timeFormat(item?.costTime * 60 ?? 0)}</p>
                                    <p>{item?.recordTime}</p>
                                </div>
                                <div>
                                    <img src={item?.cover || '/static/images/course-cover.png'} alt="" />
                                </div>
                            </div>
                        </div>
                    );
                })
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={locales.labels.noValue} />
            )}
            {page.total ? <UdeskPagination style={{marginTop: 20}} {...page} showSizeChanger={false} onChange={pageChanged} /> : null}
        </React.Fragment>
    );
}

export default CoachMsgCenterShare;
